export class SchemaFormDatePickerController {
  public static $inject = ['$scope'];
  public ngModel: any;
  public isCalendarOpen: boolean;

  constructor(private $scope) {
    // tslint:disable-next-line: forin
    for (const propertyName in $scope.vm) {
      this[propertyName] = $scope.vm[propertyName];
    }

    this.isCalendarOpen = false;
  }

  public showCalendar = () => {
    this.isCalendarOpen = true;
  }

  public calendarSave = (date) => {
    const leafModel = this.ngModel[this.ngModel.length - 1];
    const formattedDate = this.$scope.filter('date')(date, 'yyyy-MM-dd');
    leafModel.$setViewValue(formattedDate);
    this.isCalendarOpen = false;
  }
}